import { render, staticRenderFns } from "./gwfFinal.vue?vue&type=template&id=71ee1232&"
import script from "./gwfFinal.vue?vue&type=script&lang=js&"
export * from "./gwfFinal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports